/**
 * Portal API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type PlaidVerificationStatus = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;

export const PlaidVerificationStatus = {
    NUMBER_0: 0 as PlaidVerificationStatus,
    NUMBER_1: 1 as PlaidVerificationStatus,
    NUMBER_2: 2 as PlaidVerificationStatus,
    NUMBER_3: 3 as PlaidVerificationStatus,
    NUMBER_4: 4 as PlaidVerificationStatus,
    NUMBER_5: 5 as PlaidVerificationStatus,
    NUMBER_6: 6 as PlaidVerificationStatus,
    NUMBER_7: 7 as PlaidVerificationStatus,
    NUMBER_8: 8 as PlaidVerificationStatus,
    NUMBER_9: 9 as PlaidVerificationStatus,
    NUMBER_10: 10 as PlaidVerificationStatus
}